<template>
  <div class="videostream">
    <div class="filters columns" v-if="this.configs.parameters['Video pipeline'] === 'Selected by user'">
      <parametrs-list :items.sync="fieldsData.parameters" :parameters="fieldsData.properties"> </parametrs-list>
      <b-field class="apply">
        <edit-button :editOptions="['Apply']" @click="apply()">
          <template>
            <span class="text">{{ $t('button.apply') }}</span>
          </template>
        </edit-button>
      </b-field>
    </div>
    <div class="video-data">
      <audio id="audio" autoplay ref="audio"></audio>
      <video id="video" autoplay playsinline controls="controls" ref="video"></video>
    </div>
  </div>
</template>
<script>
import EditButton from '@/components/EditButton'
import ParametrsList from '@/components/ParametrsList'

export default {
  name: 'DashboardVideostream',
  components: {
    EditButton,
    ParametrsList
  },
  props: {
    id: {
      type: String
    },
    dashboardId: {
      type: String
    },
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      fieldsData: {}
    }
  },
  mounted() {
    this.rerender()
  },
  watch: {
    configs: {
      deep: true,
      immediate: true,
      handler: 'rerender'
    }
  },
  methods: {
    rerender() {
      this.fieldsData = { ...this.items }
      this.start()
    },
    start() {
      const config = {
        sdpSemantics: 'unified-plan'
      }

      if (window.settings.video.stun === '') {
        this.peerConnection = new RTCPeerConnection()
      } else {
        config.iceServers = [{ urls: [window.settings.video.stun] }]
        this.peerConnection = new RTCPeerConnection(config)
      }

      // connect audio / video
      const vm = this
      this.peerConnection.addEventListener('track', function(evt) {
        if (evt.track.kind == 'video') {
          vm.$refs.video.srcObject = evt.streams[0]
        } else {
          vm.$refs.audio.srcObject = evt.streams[0]
        }
      })
      this.negotiate()
    },
    negotiate() {
      this.peerConnection.addTransceiver('video', { direction: 'recvonly' })
      this.peerConnection.addTransceiver('audio', { direction: 'recvonly' })
      return this.peerConnection
        .createOffer()
        .then(offer => {
          return this.peerConnection.setLocalDescription(offer)
        })
        .then(() => {
          // wait for ICE gathering to complete
          return new Promise(resolve => {
            if (this.peerConnection.iceGatheringState === 'complete') {
              resolve()
            } else {
              const checkState = () => {
                if (this.peerConnection.iceGatheringState === 'complete') {
                  this.peerConnection.removeEventListener('icegatheringstatechange', checkState)
                  resolve()
                }
              }
              this.peerConnection.addEventListener('icegatheringstatechange', checkState)
            }
          })
        })
        .then(() => {
          var offer = this.peerConnection.localDescription
          const body = {
            sdp: offer.sdp,
            type: offer.type,
            size: 'f',
            watch_position: this.$refs.video.currentTime,
            dashboard_id: this.dashboardId,
            element_id: this.id.replace(this.temp, ''),
            pipeline_id: this.configs.parameters['Pipeline']
          }
          const searchParams = new URLSearchParams(body)
          const url = `${process.env.VUE_APP_API_ENDPOINT ||
            window.location.origin}/api/ui_element/stream?${searchParams}`

          return fetch(url, {
            credentials: 'include',
            body: JSON.stringify(body),
            method: 'POST'
          })
        })
        .then(res => res.json())
        .then(answer => {
          return this.peerConnection.setRemoteDescription(answer)
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },

    apply() {
      this.$emit('apply', { parameters: this.fieldsData.parameters })
    }
  }
}
</script>

<style lang="scss">
.videostream {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  .filters {
    margin: 0;
    .parametrs-list {
      margin-right: 0.75rem;
      flex-grow: 5;
      .field {
        .field-body {
          flex-grow: 5;
        }
        .field-label {
          min-width: unset;
          padding-top: 0;
          width: 100%;
          flex-basis: content;
          .label {
            text-align: right;
            width: 100%;
            min-width: unset;
          }
        }
      }
    }
  }
  .apply {
    justify-content: right;
    display: flex;
  }
}
</style>
